import {Component, OnDestroy} from "@angular/core";
import {StatsService} from "../../../services/data/stats.service";
import {BusinessGlobalStats, BusinessDatedStats} from "../../../model/business-stats";
import {DateFormatter} from "../../../model/date-formatter";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";
import {BusinessService} from "../../../services/data/business.service";
import {FamilyAlbum} from "../../../model/family-album";
import {Subscription} from "rxjs";

declare var Morris: any;
declare var $: any;

@Component({
  selector: 'stats',
  template: require('./stats.component.html'),
  styles: [
    require('./stats.component.scss')
  ]
})

export class StatsComponent implements OnDestroy {

  h: any = null;

  showChart: boolean = false;

  globalStats: BusinessGlobalStats = new BusinessGlobalStats();
  datedStats: BusinessDatedStats = new BusinessDatedStats();

  hasPictures: boolean = true;
  hasComments: boolean = true;

  myDatePickerOptions = {
    todayBtnTxt: 'Aujourd\'hui',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    inline: false,
    locale: 'fr',
    selectionTxtFontSize: '16px'
  };

  inputFromDate: string = "";
  inputToDate: string = "";

  from: number;
  to: number;

  businessId: number;

  events: FamilyAlbum[] = [];
  selectedEvent: number = -1;
  currentEvent: FamilyAlbum;

  private businessSubscription: Subscription = null;

  ngOnDestroy(): void {
    if (this.businessSubscription != null) {
      this.businessSubscription.unsubscribe();
    }
  }

  constructor(private statService: StatsService,
              private currentBusinessService: CurrentBusinessService,
              private businessService: BusinessService) {
    this.inputFromDate = DateFormatter.getFirstDayOfCurrentMonth();
    this.inputToDate = DateFormatter.getCurrentDate();
    this.to = DateFormatter.getCurrentMillis();

    if (currentBusinessService.currentBusiness == null) {
      this.businessSubscription = currentBusinessService.businessChange$.subscribe(
        business => {
          this.businessId = business.id;
          this.loadGlobalStats();
          this.loadDatedStats();
          this.loadGlobalDetail();
          this.loadEvents();
        }
      );
    } else {
      this.businessId = currentBusinessService.currentBusiness.id;

      this.loadGlobalStats();
      this.loadDatedStats();
      this.loadGlobalDetail();
      this.loadEvents();
    }
  }

  loadEvents() {
    this.businessService.getEvents(this.businessId, 0, 0).subscribe(
      page => this.events = page.content
    )
  }

  onChange(eventId: number) {
    this.selectedEvent = eventId;

    if (eventId != -1) {

      this.events.forEach(event => {
        if (event.id == this.selectedEvent) {
          this.currentEvent = event;
        }
      });

      this.from = DateFormatter.getSevenDaysEarlier(this.currentEvent.date);
      this.to = DateFormatter.getSevenDaysLater(this.currentEvent.date);
    } else {
      this.from = DateFormatter.getMillis(DateFormatter.getFirstDayOfCurrentMonth());
      this.to = DateFormatter.getMillis(DateFormatter.getCurrentDate());
    }

    this.inputFromDate = DateFormatter.format(this.from);
    this.inputToDate = DateFormatter.format(this.to);

    this.loadDatedStats();
    this.loadGlobalStats();
    this.loadGlobalDetail();
  }

  loadGlobalStats() {

    if (this.selectedEvent != -1) {
      this.statService.getEventGlobalStats(this.selectedEvent).subscribe(
        stats => this.globalStatsLoaded(stats)
      );
    } else {
      this.statService.getBusinessGlobalStats(this.businessId).subscribe(
        stats => this.globalStatsLoaded(stats)
      );
    }
  }

  loadGlobalDetail() {
    this.hasPictures = true;
    this.hasComments = true;
    let from;
    let to;

    if (this.currentEvent != null) {
      to = this.currentEvent.date;
      from = DateFormatter.getFifteenDaysEarlier(this.currentEvent.date);
    } else {
      to = new Date().getTime();
      from = DateFormatter.getFifteenDaysEarlier(to);
    }

    if (this.selectedEvent != -1) {
      this.statService.getEventDatedStats(this.selectedEvent, from, to).subscribe(
        stats => this.datedDetailLoaded(stats)
      );
    } else {
      this.statService.getBusinessDatedStats(this.businessId, from, to).subscribe(
        stats => this.datedDetailLoaded(stats)
      );
    }
  }

  loadDatedStats() {
    if (this.selectedEvent != -1) {
      this.statService.getEventDatedStats(this.selectedEvent, this.from, this.to).subscribe(
        stats => this.datedStatsLoaded(stats)
      );
    } else {
      this.statService.getBusinessDatedStats(this.businessId, this.from, this.to).subscribe(
        stats => this.datedStatsLoaded(stats)
      );
    }
  }

  datedDetailLoaded(loadedStats: BusinessDatedStats) {
    let hasPicture = false;
    let hasComment = false;

    let stats = [];

    $('#photo-chart, #comment-chart').empty();

    for (let key in loadedStats.pictures) {
      var pictureValue = loadedStats.pictures[key];
      var commentValue = loadedStats.comments[key];
      var date = DateFormatter.format(parseInt(key));

      var stat = {
        date: date,
        picture: pictureValue,
        comment: commentValue,
        timestamp: parseInt(key)
      };

      if (pictureValue > 0) {
        hasPicture = true;
      }

      if (commentValue > 0) {
        hasComment = true;
      }

      stats.push(stat);
    }

    this.hasPictures = hasPicture;
    this.hasComments = hasComment;

    let sortedStats = stats.sort((n1, n2) => {
      if (n1.timestamp > n2.timestamp) {
        return 1;
      }
      if (n1.timestamp < n2.timestamp) {
        return -1;
      }

      return 0;
    });

    if (hasPicture) {
      let photos = sortedStats.map(stat => {
        if (stat.picture == 0) {
          stat.picture = 0.1;
        }

        return stat;
      });

      new Morris.Bar({
        element: 'photo-chart',
        data: photos,
        xkey: 'date',
        ykeys: ['picture'],
        labels: ['Photos'],
        xLabels: 'day',
        resize: true,
        parseTime: false,
        hideHover: 'always',
        grid: false,
        axes: false,
        barColors: ['#5AA6D5']
      });
    }

    if (hasComment) {
      let comments = sortedStats.map(stat => {
        if (stat.comment == 0) {
          stat.comment = 0.1;
        }

        return stat;
      });

      new Morris.Bar({
        element: 'comment-chart',
        data: comments,
        xkey: 'date',
        ykeys: ['comment'],
        labels: ['Commentaires'],
        xLabels: 'day',
        resize: true,
        parseTime: false,
        hideHover: 'always',
        grid: false,
        axes: false,
        barColors: ['#F39C12']
      });
    }
  }

  datedStatsLoaded(loadedStats: BusinessDatedStats) {
    this.showChart = false;
    this.datedStats = loadedStats;

    $('#statChart').empty();

    let stats = [];

    for (let key in this.datedStats.pictures) {
      var pictureValue = this.datedStats.pictures[key];
      var commentValue = this.datedStats.comments[key];
      var date = DateFormatter.format(parseInt(key));

      var stat = {
        date: date,
        picture: pictureValue,
        comment: commentValue,
        timestamp: parseInt(key)
      };

      stats.push(stat);
    }

    let sortedStats = stats.sort((n1, n2) => {
      if (n1.timestamp > n2.timestamp) {
        return 1;
      }
      if (n1.timestamp < n2.timestamp) {
        return -1;
      }

      return 0;
    });

    new Morris.Line({
      element: 'statChart',
      data: sortedStats,
      xkey: 'date',
      ykeys: ['picture', 'comment'],
      labels: ['Photos', 'Commentaires'],
      xLabels: 'day',
      resize: true,
      parseTime: false,
      hideHover: true,
      lineColors: ['#5AA6D5', '#F39C12']
    });

    this.showChart = true;
  }

  globalStatsLoaded(stats: BusinessGlobalStats) {
    if (this.selectedEvent == -1) {
      this.globalStats = stats;
    } else {
      this.globalStats.nbComments = stats.nbComments;
      this.globalStats.nbFiles = stats.nbFiles;
      this.globalStats.nbMembers = stats.nbMembers;
    }
  }

  onDateFromChanged(event: any) {
    if (event.formatted != undefined && event.formatted != "") {
      this.from = event.epoc * 1000;

      this.loadDatedStats();
    }
  }

  onDateToChanged(event: any) {
    if (event.formatted != undefined && event.formatted != "") {
      this.to = (event.epoc * 1000) + (1000 * 60 * 60 * 24) - 1000;

      this.loadDatedStats();
    }
  }

  // events
  public clickHandler(e: any): void {
    console.log(e);
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/dashboard/stats/stats.component.ts